import { render } from "./CodeComponent.vue?vue&type=template&id=3c6d86a8&ts=true"
import script from "./CodeComponent.vue?vue&type=script&lang=ts"
export * from "./CodeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__